<template>
  <section>
    <div class="row">
      <!-- <div class="col-lg-4 d-none .d-md-none d-lg-block align-self-center">
        <div style="float:right;text-align: right;" class="col-8">
          <div class="row align-items-center">
            <span style="display: inline-block; vertical-align: middle;padding:5px">Follow Us On:</span>
            <a href="https://www.facebook.com/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon1.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.twitter.com" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon2.png"
                alt="twitter"
              />
            </a>
            <a href="https://americancredit.business.site/" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon3.png"
                alt="business site"
              />
            </a>
            <a href="https://www.linkedin.com/company/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon4.png"
                alt="linkedin"
              />
            </a>
          </div>
        </div>
      </div> -->
      <div class="offset-lg-2 col-lg-8 col-sm-12">
        <div class="step-form__main pt-3">
          <div class="row">
            <div class="col-lg-3 col-sm-12">
              <span class="step-text-active">Business Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span>Personal Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span v-if="frontAppliedProductId == 10000057823975">Equipment Details</span>
              <span v-else>Financial Review</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span>
                <a href="tel:855-904-0188">
                  <i aria-hidden="true" class="phone-icon fa fa-phone"></i>
                  855-904-0188
                </a>
              </span>
            </div>
          </div>
          <hr />

          <el-row :gutter="0">
            <el-col :span="16">
              <el-form class="step-form__form" :model="sbl01Form" :rules="rules" ref="sbl01Form">
              
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Legal business name" prop="businessName" required>
                      <el-input type="text" placeholder="Legal business name" v-model="sbl01Form.businessName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Trade name" prop="tradeName" required>
                      <el-input type="text" placeholder="Trade name" v-model="sbl01Form.tradeName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Street address" prop="streetAddress" required>
                  <el-input type="text" placeholder :maxlength="40" v-model="sbl01Form.streetAddress"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="City" prop="cityName" required>
                      <el-input type="text" placeholder :maxlength="30" v-model="sbl01Form.cityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="State"
                      prop="state"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="sbl01Form.state" placeholder="Select State">
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Zip code" prop="zipCode" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="5-digit postal code"
                        :maxlength="5"
                        v-model="sbl01Form.zipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Business phone" prop="phone" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder
                        :maxlength="10"
                        v-model="sbl01Form.phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Fax number" prop="fax">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder
                        :maxlength="10"
                        v-model="sbl01Form.fax"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Industry Type"
                      prop="industry"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="sbl01Form.industry" placeholder="Industry type">
                        <el-option
                          v-for="item in industries"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Company Structure"
                      prop="structure"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="sbl01Form.structure" placeholder="Company structure">
                        <el-option
                          v-for="item in structures"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Company website">
                      <el-input type="text" v-model="sbl01Form.url" placeholder="example.com"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="EIN (Tax ID number)" style="width: 100%;" prop="tin" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder
                        :maxlength="10"
                        v-model="sbl01Form.tin"
                        @input="handleTinInput"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Date established" prop="dateEstablished" required>
                      <el-date-picker
                        v-model="sbl01Form.dateEstablished"
                        placeholder="YYYY-MM-DD"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions1"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Annual revenue" prop="revenue" required>
                      <el-input
                        type="number"
                        v-model="sbl01Form.revenue"
                        placeholder
                        :maxlength="16"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Business description" class="margin-bottom-0" required>
                  <el-input type="textarea" placeholder="Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ration before and after loan) and what is the timing you will start to see a contribution to your revenue?" v-model="sbl01Form.description" :rows=3></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class="step-form__btn-container">
            <!--<button class="step-form__btn-prev" @click="goBack">Back step</button>-->
            <!--<button class="step-form__btn-next" @click="submitForm">Next step</button>-->

            <el-button
              type="primary"
              :loading="isLoading"
              class="rounded-pill bluebg px-5"
              @click="submitForm"
            >Next</el-button>
            <br />
            <br />
            <br />
          </div>
        </div>

        <div></div>
      </div>
      <td style="background-color:white"></td>
    </div>

    <el-dialog
      class="contract-dialog"
      top="5%"
      title="Declaration"
      :visible.sync="showAgreementDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleDialogClose"
    >
      <span slot="title"><img
        :src="require('../../assets/imgs/American Credit_logo_TM_a.png')"
        class="img-fluid logo"
        alt="American Credit Logo"
      /></span>
      <div v-if="showSignDeclarationWarning"><h4 style="color:red; text-align: center;">Please sign declaration file first.</h4></div>
      <div class="contract__dialog-body agreement_contract declaration__dialog-body">
        <img :src="readContract" alt="read" />
      </div>
      <div slot="footer" class="dialog__footer">
        <el-button
          v-if="signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="showSignAgreement"
          style="margin-right:30px;"
        >{{signBtn.text}}</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="downAgreement2"
          style="margin-right:30px;"
        >Download Declaration</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn continue_btn"
          :disabled="signBtn.state"
          @click="hideAgreement"
          style="margin-right:30px;"
        >Continue Application</el-button>
        <!--<a :href="downAgreement" class="down_agreen" download="contract">Download Contract</a>-->
      </div>
    </el-dialog>

    <el-dialog
      class="showSignDialog"
      title="Please type in your full name to sign the declaration digitally"
      :visible.sync="showSignDialog"
    >
      <el-form>
        <el-form-item>
          <el-input
            placeholder="Please input your full name to sign"
            v-model="fullName"
            auto-complete="off"
            @change="allowSubmit"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSignDialog = false">Cancel</el-button>
        <el-button type="primary" @click="signAgreement" :disabled="allowSubmitBut">Sign</el-button>
      </div>
    </el-dialog>
  </section>
</template>




<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";
import axios from 'axios';

// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
export default {
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      frontAppliedProductId: localStorage.getItem('$appliedProductId'),
      pickerOptions1: {
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let I8Years = (365 * 18 + 5) * 24 * 3600 * 1000;
          let I00Years = (365 * 100 + 26) * 24 * 3600 * 1000;
          let I8YearsDate = curDate - I8Years;
          let I00YearsDate = curDate - I00Years;
          // return time.getTime() > I8YearsDate || time.getTime() < I00YearsDate;
          return time.getTime() < I00YearsDate;
        }
      },
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: "",
      screenHeight: document.body.clientHeight,
      isApplyFirst: true,
      declarationId: 10000058500118,
      showSignDeclarationWarning: false,
      showAgreementDialog: false,
      showSignDialog: false,
      fullName: "",
      allowSubmitBut: true,
      signBtn: {
        state: false,
        text: "Sign Declaration",
        isShow: true
      },
      rules: {
        businessName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Business name can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        tradeName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Trade name can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        streetAddress: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Street Address can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        cityName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("City can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        zipCode: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Zip code can not be empty"));
              }else if (_.trim(value).length != 5 ) {
                callback(new Error("Zip code must be 5 digital"));
              }else if (!/^[0-9]*$/.test(value)) {
                callback(new Error("Input error"));
              } else {
                callback();
              }
            }
          }
        ],
        state: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("State can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],

        phone: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Business phone can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("Business phone must be 10 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ],
        tin: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("EIN can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("TIN must be 9 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ],
        industry: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Industry Type can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        structure: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Structure can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        dateEstablished: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Please enter date with correct format"));
              } else {
                callback();
              }
            }
          }
        ],
        revenue: [
          {
            require: true,
			      trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                if( value.includes("e") || value.includes("E")) {
                  callback(new Error("Input format E error"));
                }else{
                  callback(new Error("Revenue can not be empty"));
                }
              } else if (!/^[0-9]*$/.test(value)) {
                callback(new Error("Input format error"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      industries: [
        {
          value: "Agriculture (Veterinarian, Farming, etc.)",
          text: "Agriculture (Veterinarian, Farming, etc.)"
        },
        {
          value: "Construction (Building Construction, Contractors, etc.)",
          text: "Construction (Building Construction, Contractors, etc.)"
        },
        {
          value: "Finance, Insurance, or Real Estate",
          text: "Finance, Insurance, or Real Estate"
        },
        { value: "Health Services", text: "Health Services" },
        {
          value: "Manufacturing",
          text: "Manufacturing"
        },
        {
          value: "Restaurants  Bars  Catering",
          text: "Restaurants  Bars  Catering"
        },
        {
          value: "Retail",
          text: "Retail"
        },
        {
          value: "Services (Personal, Business, Legal, etc.)",
          text: "Services (Personal, Business, Legal, etc.)"
        },
        {
          value: "Transportation",
          text: "Transportation"
        },
        {
          value: "Wholesale Trade",
          text: "Wholesale Trade"
        },
        {
          value: "Other",
          text: "Other"
        }
      ],
      structures: [
        {
          value: "Sole Proprietorship",
          text: "Sole Proprietorship"
        },
        {
          value: "General Partnership",
          text: "General Partnership"
        },
        {
          value: "LLC",
          text: "LLC"
        },
        {
          value: "Single LLC",
          text: "Single LLC"
        },
        {
          value: "Corporation",
          text: "Corporation"
        },
        {
          value: "Professional Corporation",
          text: "Professional Corporation"
        }
      ],
      stateS: [],
      titleData: [],
      mastateS: [],
      isEditable: 0,
      sbl01Form: {
        businessName: "",
        tradeName: "",
        fax: "",
        description: "",
        industry: "",
        structure: "",
        dateEstablished: "",
        revenue: "",
        url: "",
        tin: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER,
      readDeclaration: types.GET_DECLARATION_IMAGE_SRC
    }),

    readContract() {
      return `${this.readDeclaration}01&loanItemContractId=${this.declarationId}`;
    },
  },
  methods: {
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    ...mapMutations({
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
    }),

    getMgxyGetPersonDetails() {
      //èŽ·å�–è¿›ä»¶ä¸ªäººä¿¡æ�¯
    },

    allowSubmit(val) {
      if (this.fullName != "") {
        this.allowSubmitBut = false;
      } else {
        this.allowSubmitBut = true;
      }
    },

    showAgreement() {
      this.showAgreementDialog = true;
    },

    hideAgreement() {
      this.showAgreementDialog = false;
    },

    showSignAgreement() {
      this.showSignDialog = true;
    },

    signAgreement() {
      const _this = this;
      var fullName = this.fullName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: this.userInfo.token,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          if (data.code === 0) {
            _this.setSuccessModal({
              show: true,
              content: data.msg
            });
            this.showSignDialog = false;
            this.declarationId = data.result;
            this.signBtn.isShow = false;
            this.signBtn.state = false;
            this.signBtn.text = "Signed";
            this.showSignDeclarationWarning = false;
          } else if (data.code === 1) {
            this.setFailModal({
              show: true,
              content: data.msg
            });
          }
        });
    },
    downAgreement2() {
      window.open(
        `/mingdao/mobile/item/pdfSignatureController/readDeclaration.ht?download=true&fileType=PDF&identify=01&loanItemContractId=${this.declarationId}`
      );
    },

    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    formatDataForSort(data) {
      var arr = [];
      var arr2 = [];
      for (var key in data) {
        arr[arr.length] = data[key];
      }
      arr.sort();
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {};
            obj.value = data[key];
            obj.text = key;
            arr2.push(obj);
          }
        }
      }
      return arr2;
    },
    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        _this.titleData = _this.formatData(res.data.result[7]);
        _this.mastateS = _this.formatData(res.data.result[6]);
      });
    },
    goBack() {
      this.$router.push({
        path: `/personalCenter/BusinessInfo`,
        query: {
          applyLoanId: this.$route.query.applyLoanId,
          isEdit: true
        }
      });
    },

    submitForm() {
      var _this = this;
      this.$refs.sbl01Form.validate(valid => {
        if (valid) {
          this.isLoading = true;
          api
            .postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
              tokenId: _this.userInfo.token,
              customerId: _this.userInfo.crmCustomerId,
              frontApplyId: _this.$route.params.id,
              
              name: _this.sbl01Form.businessName,
              tradeName: _this.sbl01Form.tradeName,
              street: _this.sbl01Form.streetAddress,
              city: _this.sbl01Form.cityName,
              state: _this.sbl01Form.state,
              zipCode: _this.sbl01Form.zipCode,
              phone: _this.sbl01Form.phone,
              tin: _this.sbl01Form.tin,
              fax: _this.sbl01Form.fax,
              industry: _this.sbl01Form.industry,
              structure: _this.sbl01Form.structure,
              dateEstablished: _this.sbl01Form.dateEstablished.toISOString(),
              revenue: _this.sbl01Form.revenue,
              website: _this.sbl01Form.url,
              businessDesc: _this.sbl01Form.description
            })
            .then(res => {
              //             alert(res.date.code);
              //             alert(res.date.msg);
              var _data = res.data;
              this.isLoading = false;
              if (_data.code == 0) {
                console.log(res);

                // hubspot update contact
                // POST request using axios with set headers
                const body = { 
                  email: _this.customerEmail,
                  data:
                  { properties: 
                    [ 
                      { property: 'company', value: _this.sbl01Form.businessName },
                      { property: 'trade_name', value: _this.sbl01Form.tradeName },
                      { property: 'business_phone', value: _this.sbl01Form.phone },
                      { property: 'business_structure_transmit', value: _this.sbl01Form.structure },
                      { property: 'business_address', value: _this.sbl01Form.streetAddress },
                      { property: 'business_city', value: _this.sbl01Form.cityName },
                      { property: 'business_state_transmit', value: _this.sbl01Form.state },
                      { property: 'business_zip_code', value: _this.sbl01Form.zipCode },
                      { property: 'website', value: _this.sbl01Form.url }
                    ] 
                  }
                };
                const headers = {
                  "Content-Type": "application/json"
                };

                axios({
                  url: '/hsapi/update_contact',
                  method: 'post',
                  baseURL: 'https://api.amcredit.com/hubspot',
                  data: body,
                  headers: headers
                })
                .then(response => console.log(response))
                .catch(error => console.log(error));

                _this.$router.push({
                  path: `/applyLoan/${this.$route.params.id}/sbl3`,
                  query: {
                    applyLoanId: this.$route.query.applyLoanId,
                    isEdit: this.$route.query.isEdit
                  }
                });
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    },

    handleTinInput(value) {
      var newValue = value.replaceAll("-", "");
      if (newValue.length > 2) {
        this.sbl01Form.tin = newValue.substr(0, 2) + "-" + newValue.substr(2);
      }
    },

    handleDialogClose(done) {
      if(this.declarationId == null || this.declarationId == 10000058500118) {
        this.showSignDeclarationWarning = true;
      } else {
        done();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf("register") !== -1) {
      next(false);
    } else {
      next();
    }
  },

  mounted() {
    this.getMgxyDictionary();
    this.getPersonalInitData({
      token: this.userInfo.token,
      customerId: this.userInfo.crmCustomerId
    }).then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        console.log(data.declarationId);
        console.log(typeof data.declarationId);
        this.customerEmail = data.email;
        if(data.declarationId == null || data.declarationId == 10000058500118) {
          this.showAgreementDialog = true;
        } else {
          this.declarationId = data.declarationId;
        }
      }
    });
  }
};
</script>

<style lang="scss">
.logo {
  display: block;
  width: 13vw;
  min-width: 14em;
  max-width: 250px;
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 8%;
}

.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.dialog__footer__confirm-btn.continue_btn {
  background-color: #00c0ff;
}
</style>



// WEBPACK FOOTER //
// sbl01.vue?2a85c27a